export const EMPTY_STATE = {
  case_details: {
    case_id: "",
    short_id: "",
    date_ordered: "",
    cancellation_reason: null,
  },
  checks: [],
  applicant_info: {
    email: "",
    current_name: {
      given_name: "",
      additional_name: "",
      family_name: "",
    },
    current_location: {
      street_address: "",
      unit_number: "",
      locality: "",
      administrative_division_1: "",
      country: "",
      postal_code: "",
    },
    date_of_birth: "",
  },
  date_completed: "",
  date_generated: "",
};
